// extracted by mini-css-extract-plugin
module.exports = {"course-tab-view-wrapper":"CourseTabView_course-tab-view-wrapper__nZZ3w"};